import { FEscalaStyle } from "./styles";
import { Button, Grid } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BackDrop from "../../../global/BackDrop";
import { ToastMessage } from "../../../global/ToastMessage";
import { 
    crearEscalaVueloAction, 
    crearEscalaVueloRegresoAction, 
    obtenerEscalasVueloAction, 
    obtenerEscalasVueloRegresoAction 
} from "../../../ducks/proveedorAereolineaDuck";
import TablaEscalasVuelos from "../TEscalasVuelos";
import AutoInputIATA from "../AutoInputIATA";

const InitialValueEscala = {
    IdCodigo: 0,
    CodigoIATA: "",
    Nombre: "",
    Descripcion: ""
}

const TEscalasVuelos = ({ tipo }) => {
    const classes = FEscalaStyle();
    const dispatch = useDispatch();
    const [escalaVuelo, setEscalaVuelo] = useState(InitialValueEscala)
    const [isLoad, setIsLoad] = useState(false);
    const { vueloTarget, circuitoSelect } = useSelector(store => store.proveedorTerrestre);
    const { escalasVuelo, escalasVueloRegreso } = useSelector(store => store.vueloProveedor);

    const rows = useMemo(() => {
        const escalas = tipo === "ida" 
            ? escalasVuelo ?? [] 
            : escalasVueloRegreso ?? []
        return escalas
    },[escalasVuelo, escalasVueloRegreso, tipo]);

    const LimpiarForm = () => {
        setEscalaVuelo(InitialValueEscala);
    };

    useEffect(() => {
        setIsLoad(true);
        const proveedor = {
            idVueloProveedor: vueloTarget?.IdVueloProveedor,
        }
        const regresoProveedor = {
            idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo,
        }
        const getDispatchAction = tipo === "regreso" 
            ? obtenerEscalasVueloRegresoAction
            : obtenerEscalasVueloAction;
        
        const getData = tipo === "regreso" ? regresoProveedor : proveedor;
        
        dispatch(getDispatchAction(getData)).then(() => {
            setIsLoad(false);
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [circuitoSelect?.IdPaqueteCircuito])

    const onSave = () => {
        if (escalaVuelo.IdCodigo > 0) {
            if (!rows.find(escala => escala.IdCodigo === escalaVuelo.IdCodigo)){
                const payload = {
                    idVueloProveedor: vueloTarget?.IdVueloProveedor,
                    idCodigo: escalaVuelo?.IdCodigo,
                }

                const payloadRegreso = {
                    idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo,
                    idCodigo: escalaVuelo?.IdCodigo,
                }
                const escalaPayload = tipo === "regreso" ? payloadRegreso : payload;
            
                const dispatchAction = tipo === "regreso" 
                    ? crearEscalaVueloRegresoAction
                    : crearEscalaVueloAction;

                dispatch(dispatchAction(escalaPayload)).then((Response) => {
                    switch (Response.status) {
                        case 500:
                            ToastMessage.fire({
                                icon: "error",
                                title: "Ha habido un problema de conexión con el servidor",
                            });
                        break;
                        case 400:
                            ToastMessage.fire({
                                icon: "warning",
                                title: "<strong>Atención</strong>",
                                text: "Error al crear escala.",
                            });
                        break;
                        default:
                            LimpiarForm();
                            ToastMessage.fire({
                                icon: "success",
                                title: "<strong>Creado</strong>",
                                text: "Escala creada exitosamente.",
                            });
                            
                            const proveedor = {
                                idVueloProveedor: vueloTarget?.IdVueloProveedor,
                            }

                            const regresoProveedor = {
                                idVueloRedondo: vueloTarget?.VueloRedondo?.IdVueloRedondo,
                            }
                            
                            const getDispatchAction = tipo === "regreso" 
                                ? obtenerEscalasVueloRegresoAction
                                : obtenerEscalasVueloAction;
                            
                            const getData = tipo === "regreso" ? regresoProveedor : proveedor;
                            
                            dispatch(getDispatchAction(getData)).then(() => {
                                setIsLoad(false);
                            })
                        break;
                    }
                })
            } else {
                ToastMessage.fire({
                    icon: "warning",
                    title: "<strong>Atención</strong>",
                    text: "Esta escala ya fue agregada.",
                });
            }
        } else {
             ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Seleccione los campos correctamente.",
            });
        }
    }

    return (
        <Grid container className={classes.modal}>
            <Grid item xs={6} className={classes.tabContainer}>
                <TablaEscalasVuelos tipo={tipo}/>
            </Grid>

            <Grid item xs={6} className={classes.tabContainer}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.containerSpacingItem} >
                        <AutoInputIATA
                            label="Escala"
                            name="Escala"
                            setTarget={setEscalaVuelo}
                            value={escalaVuelo}
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            onClick={onSave}
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            disabled={escalaVuelo.IdCodigo > 0 ? false : true}
                        >
                            Agregar escala de {tipo}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <BackDrop open={isLoad} />
      </Grid>
    )
}

export default TEscalasVuelos;